import { MODULE_PATHS } from '../../_app/language/language.service';
import { ModalNamesToPaths } from '../../../models/Modal.model';

// TODO add modal names here
export enum ModalName {
    deleteUser = 'delete-user-modal',
    deleteProject = 'delete-project-modal',
    deleteContact = 'delete-contact-modal',
    addContact = 'add-contact-modal',
    deleteInteraction = 'delete-interaction-modal',
    deleteMeter = 'delete-meter-modal',
    deleteEquipment = 'delete-equipment-modal',
    deleteSpace = 'delete-space-modal',
    deleteSupplier = 'delete-supplier-modal',
    deleteTenant = 'delete-tenant-modal',
    addOrganisation = 'add-organisation-modal',
    deleteOrganisation = 'delete-organisation-modal',
    deleteIntervention = 'delete-intervention-modal',
    gallery = 'gallery-modal',
    deleteFeedback = 'delete-feedback-modal',
    deleteTenantContract = 'delete-tenant-contract-modal',
    deleteAgent = 'delete-agent-modal',
    deleteQuality = 'delete-quality-modal',
    deleteDimension = 'delete-dimension-modal',
    deleteProduct = 'delete-product-modal',
    deleteBuildingReport = 'delete-building-report-modal',
    deletePermit = 'delete-permits-modal',
    deleteOffer = 'delete-offer-modal',
    deleteSupplierInvoice = 'delete-suppliers-invoice-modal',
    deleteMeterReading = 'delete-meter-reading-modal',
    deleteLead = 'delete-lead-modal',
    leadDetails = 'lead-details-modal',
    leadLost = 'lead-lost-modal',
    leadConvert = 'lead-convert-modal',
    deleteClient = 'delete-client-modal',
    deleteRfq = 'delete-rfq-modal',
    deleteTransaction = 'delete-transaction-modal',
    addRfq = 'add-rfq-modal',
    addProductsAuto = 'add-products-auto-modal',
    verifyRequestOffer = 'verify-request-offer-modal',
    addOffer = 'add-offer-modal',
    refuseOffer = 'refuse-offer-modal',
    acceptOffer = 'accept-offer-modal'
};

export const MODAL_NAMES_TO_PATHS: ModalNamesToPaths = {
    [MODULE_PATHS.ADMIN]: {
        [ModalName.deleteUser]: () => {
            return import('../../../../_pages/admin/components/delete-user-modal/delete-user-modal.component');
        },
        [ModalName.deleteAgent]: () => {
            return import('../../../../_pages/admin/components/delete-agent-modal/delete-agent-modal.component');
        },
        [ModalName.deleteOrganisation]: () => {
            return import('../../../../_pages/admin/components/delete-organisation-modal/delete-organisation-modal.component');
        },
        [ModalName.deleteQuality]: () => {
            return import('../../../../_pages/admin/components/delete-quality-modal/delete-quality-modal.component');
        },
        [ModalName.deleteDimension]: () => {
            return import('../../../../_pages/admin/components/delete-dimension-modal/delete-dimension-modal.component');
        },
        [ModalName.deleteProduct]: () => {
            return import('../../../../_pages/admin/components/delete-product-modal/delete-product-modal.component');
        }
    },
    [MODULE_PATHS.DASHBOARD]: {
        // [ModalName.deleteProject]: () => {
        //     return import('../../../../_pages/dashboard/layout/delete-project-modal/delete-project-modal.component');
        // },
        // [ModalName.deleteContact]: () => {
        //     return import('../../../../_pages/dashboard/layout/delete-contact-modal/delete-contact-modal.component');
        // },
        // [ModalName.deleteMeter]: () => {
        //     return import('../../../../_pages/dashboard/layout/delete-meter-modal/delete-meter-modal.component');
        // },
        // [ModalName.deleteEquipment]: () => {
        //     return import('../../../../_pages/dashboard/layout/delete-equipment-modal/delete-equipment-modal.component');
        // },
        // [ModalName.deleteSpace]: () => {
        //     return import('../../../../_pages/dashboard/layout/delete-space-modal/delete-space-modal.component');
        // },
        // [ModalName.deleteSupplier]: () => {
        //     return import('../../../../_pages/dashboard/layout/delete-supplier-modal/delete-supplier-modal.component');
        // },
        // [ModalName.deleteTenant]: () => {
        //     return import('../../../../_pages/dashboard/layout/delete-tenant-modal/delete-tenant-modal.component');
        // },
        // [ModalName.addOrganisation]: () => {
        //     return import('../../../../_pages/dashboard/layout/add-organisation-modal/add-organisation-modal.component');
        // },
        // [ModalName.deleteTenantContract]: () => {
        //     return import('../../../../_pages/dashboard/components/delete-tenant-contract-modal/delete-tenant-contract-modal.component');
        // }
    },
    [MODULE_PATHS.FACILITY]: {
        // [ModalName.gallery]: () => {
        //     return import('../../../../_pages/facility/modals/gallery-modal/gallery-modal.component');
        // },
        // [ModalName.deleteIntervention]: () => {
        //     return import('../../../../_pages/facility/components/delete-intervention/delete-intervention.component');
        // },
        // [ModalName.deleteFeedback]: () => {
        //     return import('../../../../_pages/facility/components/delete-feedback-modal/delete-feedback-modal.component');
        // }
    },
    [MODULE_PATHS.PROPERTY]: {
        // [ModalName.deleteSupplierInvoice]: () => {
        //     return import('../../../../_pages/property/components/delete-suppliers-invoice-modal/delete-suppliers-invoice-modal.component');
        // },
        // [ModalName.deleteMeterReading]: () => {
        //     return import('../../../../_pages/property/components/delete-meter-reading-modal/delete-meter-reading-modal.component');
        // }
    },
    [MODULE_PATHS.CLIENTS]: {
        [ModalName.deleteInteraction]: () => {
            return import('../../../../_pages/clients/components/delete-interaction-modal/delete-interaction-modal.component');
        },
        [ModalName.deleteClient]: () => {
            return import('../../../../_pages/clients/components/delete-client-modal/delete-client-modal.component');
        },
        [ModalName.deleteContact]: () => {
            return import('../../../../_pages/clients/components/delete-contact-modal/delete-contact-modal.component');
        },
        [ModalName.addContact]: () => {
            return import('../../../../_pages/clients/components/add-contact-modal/add-contact-modal.component');
        }
    },
    [MODULE_PATHS.RFQS]: {
        [ModalName.deleteRfq]: () => {
            return import('../../../../_pages/rfqs/children/rfqdetails/components/delete-rfq-modal/delete-rfq-modal.component');
        },
        [ModalName.addRfq]: () => {
            return import('../../../../_pages/rfqs/components/add-rfq-modal/add-rfq-modal.component');
        },
        [ModalName.addProductsAuto]: () => {
            return import('../../../../_pages/rfqs/children/rfqdetails/components/add-products-auto-modal/add-products-auto-modal.component');
        },
        [ModalName.verifyRequestOffer]: () => {
            return import('../../../../_pages/rfqs/children/rfqdetails/components/verify-request-offer-modal/verify-request-offer-modal.component');
        }
    },
    [MODULE_PATHS.CLOFFERS]: {
        [ModalName.refuseOffer]: () => {
            return import('../../../../_pages/cloffers/children/clofferdetails/components/refuse-offer-modal/refuse-offer-modal.component');
        },
        [ModalName.acceptOffer]: () => {
            return import('../../../../_pages/cloffers/children/clofferdetails/components/accept-offer-modal/accept-offer-modal.component');
        }
        // TODO: Implement add-offer-modal component
        // [ModalName.addOffer]: () => {
        //     return import('../../../../_pages/cloffers/components/add-offer-modal/add-offer-modal.component');
        // }
    },
    [MODULE_PATHS.LEADS]: {
        [ModalName.deleteLead]: () => {
            return import('../../../../_pages/leads/components/delete-lead-modal/delete-lead-modal.component');
        },
        [ModalName.leadDetails]: () => {
            return import('../../../../_pages/leads/components/lead-details-modal/lead-details-modal.component');
        },
        [ModalName.leadLost]: () => {
            return import('../../../../_pages/leads/components/lead-lost-modal/lead-lost-modal.component');
        },
        [ModalName.leadConvert]: () => {
            return import('../../../../_pages/leads/components/lead-convert-modal/lead-convert-modal.component');
        }
    }
};